import React from "react";

export const Marquee = () => {
  const copies = ["a", "b", "c", "d", "e", "f"];
  return (
    <div className="relative border-y border-[var(--border)] py-6 overflow-hidden bg-[#0A0D10]" data-testid="brand-marquee">
      <div className="marquee-track">
        {copies.map((id) => (
          <span key={id} className="font-display text-2xl sm:text-3xl font-medium tracking-tight mr-10 flex items-center">
            <span className="text-white/90">SCIENCE</span>
            <span className="mx-6 text-cyan">•</span>
            <span className="text-white/90">SIGNALS</span>
            <span className="mx-6 text-emerald">•</span>
            <span className="text-white/90">SYSTEMS</span>
            <span className="mx-6 text-gold">•</span>
          </span>
        ))}
      </div>
      <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#0A0D10] to-transparent" />
      <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#0A0D10] to-transparent" />
    </div>
  );
};
